import { render, staticRenderFns } from "./calendar-settings-dialog.vue?vue&type=template&id=2c0dfa9c&scoped=true"
import script from "./calendar-settings-dialog.vue?vue&type=script&lang=js"
export * from "./calendar-settings-dialog.vue?vue&type=script&lang=js"
import style0 from "./calendar-settings-dialog.vue?vue&type=style&index=0&id=2c0dfa9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0dfa9c",
  null
  
)

export default component.exports